<template>
  <div class="icon-model" :class="[length-1 == index ? '':'icon-ex']">
    <div class="icon-type-title">{{category}}</div>
    <div v-for="item in facilities" :key="item.id" class="icon-item col-3">
      <img class="icon" :src="item.icon || ''" :onerror="defaultImg" />
      <div class="name">{{getName(item.name)}}<span v-if="item.isFeature" class="is-characteristic">●</span>
      <img v-if="item.tag" class="icon-big" :src="item.tag" :onerror="defaultImg" />
      </div>
    </div>
    <div class="common-clr"></div>
  </div>
</template>

<script>
export default {
  name: "DeviceGroupTags",
  props: {
    category: {
      type: String,
      default: ""
    },
    index: {
      type: Number,
      default: 0
    },
    length: {
      type: Number,
      default: 0
    },
    facilities: {
      type: Array,
      default: null
    }
  },
  computed: {
    defaultImg() {
      return "this.src = 'https://resource.rcclchina.com.cn/common/default/icon-default.png'"
    }
  },
  methods: {
    getName(name) {
      return name.lastIndexOf('-') >= 0 ? name.substr(0, name.lastIndexOf('-')) : name;
    }
  }
}
</script>

<style lang="less" scoped>
.icon-ex{
  padding-bottom: 10px;
  box-sizing: border-box;
  border-bottom: 1px solid #f1f1f1;
}
.icon-model {
  margin-top: 20px;
  &:first-child {
    margin-top: 0;
  }
}
.icon-type-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
  color: #333333;
}
.icon-item {
  padding: 6px 0;
  overflow: hidden;
  font-size: 14px;
  color: #747d80;
  &.col-3 {
    float: left;
    width: 30%;
    margin-right: 3.33%;
  }
  & .icon {
    float: left;
    display: block;
    height: 14px;
    width: 14px;
    margin-right: 8px;
  }
  & .name {
    overflow: hidden;
    margin-top: -2px;
    line-height: 18px;
    display: flex;
    align-items: center;

  }
  & .is-characteristic {
    font-size: 12px;
    margin-left: 4px;
    color: #0173BC;
  }
}
.icon-big{
  width: 60px;
  height: 17px;
  margin-left: 8px;
}
</style>
